import { Agreement, AgreementKey } from 'types/Agreement';

const isSameAgreement = (
  agreement: Agreement,
  agreementKey: AgreementKey,
  tinyAccountId: string,
  kitId: string | null,
) =>
  agreement.agreement_key === agreementKey &&
  agreement.tinyaccount_id === tinyAccountId &&
  agreement.kit_id === kitId;

export const findAgreement = (
  agreements: Agreement[],
  agreementKey: AgreementKey,
  tinyAccountId: string,
  kitId: string,
) =>
  agreements.find(agreement =>
    isSameAgreement(agreement, agreementKey, tinyAccountId, kitId),
  );

// the server keeps one row per (tinyaccount_id, agreement_key, kit_id), so a
// repeat agreement replaces the stored one rather than appending to it
export const upsertAgreement = (
  agreements: Agreement[],
  agreement: Agreement,
): Agreement[] => [
  ...agreements.filter(
    existing =>
      !isSameAgreement(
        existing,
        agreement.agreement_key,
        agreement.tinyaccount_id,
        agreement.kit_id,
      ),
  ),
  agreement,
];
